import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IoMdHome } from "react-icons/io";
import { FaHotel, FaUmbrellaBeach, FaHeart } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import { MdCall } from "react-icons/md";
import { CiStreamOn } from "react-icons/ci";
import "./NavbarMain.css";

const NavbarMain = () => {
  return (
    <>
      <input type="checkbox" id="menuToggle" hidden />
      <label htmlFor="menuToggle" className="navbar-toggle">☰</label>

      <div className="Navbar_Main">
        <Container>
          <div className="Navbar_Main-MenuBar">
            <div className="Navbar_Main-LeftGroup">
              <Link to="/" className="logo-section">
                <img className="logo-main" src="/Images/tour/logo.jpeg" alt="Logo" />
              </Link>

              <div className="nav-links">
                <Link to="/" className="nav-item-link">
                  <IoMdHome className="nav-icon" />
                </Link>

                {/* International Dropdown */}

                <div className="nav-item-link dropdown">
                  <div className="dropdown-toggle">
                    Tour Packages 
                  </div>
                  <div className="dropdown-menu">
                    <Link to="/delhi-agra-tour" className="dropdown-item">Delhi Agra Tour</Link>
                    <Link to="/golden-triangle-tour" className="dropdown-item">Golden Triangle Tour</Link>
                    <Link to="/udaipur-mount-abu-jodhpur-tour" className="dropdown-item">Udaipur Mount Abu Jodhpur Tour</Link>
                    <Link to="/triangle-with-ajmer-pushkar" className="dropdown-item">Triangle with Ajmer Pushkar</Link>
                    <Link to="/rajasthan-desert-tour" className="dropdown-item">Rajasthan Desert Tour</Link>
                    <Link to="/rajasthan-royal-heritage-tour" className="dropdown-item">Rajasthan Royal Heritage Tour</Link>
                  </div>
                </div>

                {/* Domestic Dropdown */}
                <div className="nav-item-link dropdown">
                  <div className="">
                     Rental Cars
                  </div>
                  {/* <div className="dropdown-menu">
                    <Link to="/" className="dropdown-item">2 Nights 3 Days</Link>
                    <Link to="/" className="dropdown-item">3 Nights 4 Days</Link>
                    <Link to="/" className="dropdown-item">4 Nights 5 Days</Link>
                    <Link to="/" className="dropdown-item">5 Nights 6 Days</Link>
                    <Link to="/" className="dropdown-item">6 Nights 7 Days</Link>
                    <Link to="/" className="dropdown-item">7 Nights 8 Days</Link>
                    <Link to="/" className="dropdown-item">8 Nights 9 Days</Link>
                  </div> */}
                </div>

                <div className="nav-item-link dropdown">
                  <div className="">
                    Hotel Booking
                  </div>
                  {/* <div className="dropdown-menu">
                    <Link to="/" className="dropdown-item">2 Nights 3 Days</Link>
                    <Link to="/" className="dropdown-item">3 Nights 4 Days</Link>
                    <Link to="/" className="dropdown-item">4 Nights 5 Days</Link>
                    <Link to="/" className="dropdown-item">5 Nights 6 Days</Link>
                    <Link to="/" className="dropdown-item">6 Nights 7 Days</Link>
                    <Link to="/" className="dropdown-item">7 Nights 8 Days</Link>
                    <Link to="/" className="dropdown-item">8 Nights 9 Days</Link>
                  </div> */}
                </div>

                  <div className="nav-item-link dropdown">
                  <div className="">
                   <Link to="/about-us" className="footer-link">
                      About Us
                    </Link> 
                  </div>
                  {/* <div className="dropdown-menu">
                    <Link to="/scuba-diving" className="dropdown-item">Scuba Diving</Link>
                    <Link to="/sea-walk" className="dropdown-item">Sea Walk</Link>
                    <Link to="/snorkeling" className="dropdown-item">Snorkeling</Link>
                    <Link to="/paragliding" className="dropdown-item">Paragliding</Link>
                    <Link to="/sea-kart" className="dropdown-item">Sea Kart</Link>
                    <Link to="/banana-ride" className="dropdown-item">Banana Ride</Link>
                    <Link to="/jet-skie" className="dropdown-item">Jet-Skie</Link>
                  </div> */}
                </div>

                  {/* <div className="nav-item-link dropdown">
                  <div className="dropdown-toggle">
                    Ferries
                  </div>
                  <div className="dropdown-menu">
                    <Link to="/makruzz" className="dropdown-item">Makruzz</Link>
                    <Link to="/green-ocean" className="dropdown-item">Green Ocean</Link>
                    <Link to="/nautika" className="dropdown-item">Nautika</Link>
                  </div>
                </div> */}
                 <Link to="/contact" className="nav-item-link">
                Contact Us
              </Link>


              </div>
            </div>
              <div className="Navbar_Main-RightGroup">
                <a href="mailto: budgetgoldentriangletours@gmail.com" className="contact-btn email-btn">
                  <FaEnvelope className="nav-icon" style={{ color: 'white' }} />  budgetgoldentriangletours@gmail.com
                </a>

                <a href="tel: +91-9911363366" className="contact-btn">
                  <MdCall className="nav-icon" style={{ color: 'white' }} />  +91-9911363366
                </a>
              </div>
 
          </div>
        </Container>
      </div>
    </>
  );
};

export default NavbarMain;
